import React, { useState } from "react"
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap"

const ClientContactInfo = ({ clientContactToggle, selectedItem }) => {
  const [modal, setmodal] = useState(true)
  const toggle = () => clientContactToggle()
  const onClose = () => clientContactToggle()

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-md">
      <ModalHeader>
        Client Contact Info
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={onClose}
        />
      </ModalHeader>

      <ModalBody>
        <h5 className="text-center">Client Contact (provided by Tawuniya)</h5>

        <Table>
          <tbody>
            <tr>
              <th>Name</th>
              <td>{selectedItem.AddUName}</td>
            </tr>
            <tr>
              <th>Phone</th>
              <td>{selectedItem.AddUMobile}</td>
            </tr>
            <tr>
              <th>Email</th>
              <td>{selectedItem.AddUEmail}</td>
            </tr>
          </tbody>
        </Table>

        <hr />
        <h5 className="text-center">Client Contact (provided by Client)</h5>

        <Table>
          <tbody>
            <tr>
              <th>Name</th>
              <td>{selectedItem.AddCName}</td>
            </tr>
            <tr>
              <th>Phone</th>
              <td>{selectedItem.AddCMobile}</td>
            </tr>
            <tr>
              <th>Email</th>
              <td>{selectedItem.AddCEmail}</td>
            </tr>
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  )
}

export default ClientContactInfo
